import { Fingerprint } from 'lucide-react';
import { copy } from '../copy/copy';
import { useLanguage } from '../lib/LanguageContext';
import { Bilingual } from './Bilingual';

interface ParticipantNipBadgeProps {
  nip: string | null;
  className?: string;
}

/** A compact, read-only academic identity marker for participant-facing pages. */
export function ParticipantNipBadge({ nip, className = '' }: ParticipantNipBadgeProps) {
  const { t } = useLanguage();

  if (!nip) return null;

  return (
    <span
      aria-label={`${t(copy.profile.participantNipShort)} ${nip}`}
      className={`inline-flex items-center gap-2 rounded-xl bg-primary/10 px-3 py-2 text-primary ${className}`}
    >
      <Fingerprint size={16} aria-hidden="true" />
      <span className="text-[10px] font-label font-bold uppercase tracking-[0.12em]">
        <Bilingual {...copy.profile.participantNipShort} />
      </span>
      <span className="font-mono text-xs font-bold tracking-wide">{nip}</span>
    </span>
  );
}
